'use client';

import { useTranslations } from 'next-intl';
import type { FC, PropsWithChildren } from 'react';
import { ImageWithPlaceholder } from '@/app/components/shared/ImageWithPlaceholder';
import { HoverCard, HoverCardContent, HoverCardTrigger } from '@/app/components/ui/hover-card';
import { cn } from '@/app/utils';
import type { Sample } from '../types';

interface SampleSelectHoverCardProps {
  samples: Sample[];
  onSelect: (imageUrl: string) => void;
  className?: string;
}

export const SampleSelectHoverCard: FC<PropsWithChildren<SampleSelectHoverCardProps>> = ({
  samples,
  onSelect,
  className,
  children,
}) => {
  const t = useTranslations();

  if (!samples.length) return children;

  return (
    <HoverCard openDelay={0} closeDelay={100}>
      <HoverCardTrigger asChild={true}>{children}</HoverCardTrigger>
      <HoverCardContent
        className={cn('max-h-[246px] w-fit max-w-[438px] overflow-y-auto p-3', className)}
        align="center"
        sideOffset={8}
      >
        <p className="mb-2 text-sm text-system-white">{t('templates.pickFromGallery')}</p>
        <div className="flex flex-wrap gap-3">
          {samples.map((sample) => (
            <div key={sample.imageUrl} className="rounded-12 hover:outline hover:outline-system-white">
              <ImageWithPlaceholder
                key={sample.imageUrl}
                src={sample.imageUrl}
                alt="sample image"
                onClick={() => onSelect(sample.imageUrl)}
                className="relative aspect-[3/4] w-[70px] cursor-pointer rounded-12 border border-system-white16 bg-black/40 object-cover"
              />
            </div>
          ))}
        </div>
      </HoverCardContent>
    </HoverCard>
  );
};
